import React from 'react';
import styles from './new-couples.module.scss';
import { CouplesItemLike } from './components/couples-item-like';
import { couplesItems } from '@/mocks/couples-items';
import { Container, Typography } from '@/ui-kit';
import { Profile } from '@/types/profile';
import { useCurrentChatInfo } from '@/store/useCurrentChatInfo';
import HeartImage from '@/assets/images/subscription/badge-heart.png';
import { generatePath } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { CouplesItem, SkeletonCouplesItem } from './components/couples-item';
import { useGetLikesCounter } from '@/hooks/use-get-like-counter';
import { Couples } from '@/types/chat';
import { useTranslation } from 'react-i18next';

interface Props {
    isLoading: boolean;
    matches?: Couples[] | null;
}

export const NewCouples: React.FC<Props> = ({ isLoading, matches }) => {
    const handleCurrentChat = useCurrentChatInfo((state) => state.setCurrentChat);

    const { data: likesData } = useGetLikesCounter()
    const hasLikes = (
            likesData
                ?.data
                ?.count ?? 0
        ) > 0

    const { t } = useTranslation();

    return (
        hasLikes ||
        (
            matches
                ?.length ?? 0
        ) > 0 ?
            <div className={styles.wrapper}>
                <Container>
                    <div className={styles.label}>
                        <Typography
                            typeColor="gray"
                            uppercase
                            variant="span">
                            {t('msgs.new_couples')}
                        </Typography>
                    </div>
                </Container>
                <div className={styles.list}>
                    {
                        isLoading ?
                            (
                                Array.from({ length: 5 }).map((_, index) => <SkeletonCouplesItem key={index} />)
                            )
                        :
                            (
                                <>
                                    {
                                        hasLikes ?
                                            <CouplesItemLike
                                                avatar={HeartImage}
                                                count={couplesItems.length}
                                                href={routesApp.liked} />
                                        :
                                            <></>
                                    }
                                    {matches?.map((match) => {
                                        return (
                                            <CouplesItem
                                                key={match.profile.id}
                                                href={generatePath(routesApp.chat, { id: String(match.chat_id) })}
                                                info={match.profile.public_name}
                                                avatar={match.profile.photos.length > 0 ? match.profile.photos[0].thumb_url : null}
                                                isOnline={match.profile.is_online}
                                                expiredAt={match.expired_at}
                                                onClick={() => handleCurrentChat(match.profile)} />
                                        );
                                    })}
                                </>
                            )
                    }
                </div>
            </div>
        :
            <></>
    );
};
